import React from 'react';
import { useSelector } from 'react-redux';
import ExpandTableButton from '../ExpandTableButton/ExpandTableButton';
import styles from './ExperimentDetailViewConfiguration.module.scss';
import { getIsHeaderTableShown } from '@/reducers/experimentDetails/uiReducer';
import ExperimentDetailsViewSelect from '../ExperimentDetailsViewSelect/ExperimentDetailsViewSelect';
import useExperimentDetailIsTableShown from './hooks/useExperimentDetailIsTableShown';
import useExpTemplateList from '@experiment-details/hooks/template/useExpTemplateList';

type ExperimentDetailViewConfigurationProps = {
  isComparisonView?: boolean;
};
const ExperimentDetailViewConfiguration: React.FC<ExperimentDetailViewConfigurationProps> = ({
  isComparisonView = false
}) => {
  const isHeaderTableShown = useSelector(getIsHeaderTableShown);

  const { isLoading } = useExpTemplateList();
  const { handleClickIsTableShown } = useExperimentDetailIsTableShown();

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.experimentDetailRouteWrapper}>
      <ExperimentDetailsViewSelect />

      <ExpandTableButton
        isOpened={isHeaderTableShown}
        onClick={handleClickIsTableShown}
        isComparisonView={isComparisonView}
      />
    </div>
  );
};

export default ExperimentDetailViewConfiguration;
